import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";
import { ErrorResponse } from "@reflag/shared/api";
import { FeatureFeedbackCampaignDTO } from "@reflag/shared/featureFeedbackAPI";

export default function useFeatureFeedbackCampaignData(featureId?: string) {
  const { appId, envId } = useEnvironment();

  return useQuery<FeatureFeedbackCampaignDTO, AxiosError<ErrorResponse>>({
    queryKey: featureQueryKeys.singleFeatureFeedbackCampaign(
      appId,
      envId,
      featureId,
    ),

    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/feedback/campaigns">(
          `/apps/${appId}/features/${featureId}/feedback/campaigns`,
          { params: { envId: envId! } },
        )
        .then((res) => res.data[0] ?? null),
    enabled: !!appId && !!envId && !!featureId,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
